import { createReducer } from '@topconagriculture/frontend-utils';
import { DateLike } from '@topconagriculture/language';

import {
  getNextOrderData,
  fetchOrderList,
  setOrders,
  getIngredientReceiveData,
  resetIngredient,
} from './orders.actions';
import { Order } from './orders.types';
import { IngredientInOrder } from '../ingredients/ingredients.types';

export type OrderState = {
  nextOrderNumber: number | null;
  nextOrderDate: DateLike | null;
  receivingIngredient: IngredientInOrder | null;
  orders: Order[];
};

export const initialState: OrderState = {
  nextOrderNumber: null,
  nextOrderDate: null,
  orders: [],
  receivingIngredient: null,
};

const ordersReducer = createReducer(initialState, {
  [fetchOrderList.done.type]: (state: OrderState, action: ReturnType<typeof fetchOrderList.done>) => ({
    ...state,
    orders: action.payload.result,
  }),
  [getNextOrderData.done.type]: (state: OrderState, action: ReturnType<typeof getNextOrderData.done>) => {
    const { requestNo, requestDate } = action.payload.result;

    return {
      ...state,
      nextOrderNumber: requestNo,
      nextOrderDate: requestDate,
    };
  },
  [setOrders.type]: (state: OrderState, action: ReturnType<typeof setOrders>) => {
    return { ...state, orders: action.payload };
  },
  [getIngredientReceiveData.done.type]: (
    state: OrderState,
    action: ReturnType<typeof getIngredientReceiveData.done>,
  ) => {
    return { ...state, receivingIngredient: action.payload.result };
  },
  [resetIngredient.type]: (state: OrderState) => {
    return { ...state, receivingIngredient: null };
  },
});

export default ordersReducer;
